import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import { GetAllPages } from '../services/pageservice';
import Spinner from '../components/Spinner'; // Optional: Add a spinner for loading

function PagesList() {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const { successMessage } = location.state || {};
    const navigate = useNavigate();

    const totalPages = Math.ceil(totalCount / pageSize);

    useEffect(() => {
        fetchData(page, pageSize);
        if (successMessage) toast.success(successMessage);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize]);

const fetchData = async (currentPage = 1, currentPageSize = 50) => {
    try {
        setLoading(true);
        const response = await GetAllPages(currentPage, currentPageSize);
        const jsonData = typeof response === 'string' ? JSON.parse(response) : response;

        setData(jsonData.pages || []);
        setTotalCount(jsonData.totalCount || 0);
        setLoading(false);
    } catch (error) {
        console.error('Error fetching pages:', error);
        setLoading(false);
        toast.error('Failed to load pages');
    }
};


    const handleEdit = (id) => {
        navigate('/page/add?pk=' + id);
    };

    const changePage = (p) => {
        if (p >= 1 && p <= totalPages) setPage(p);
    };

    const pageNumbers = () => {
        const pages = [];
        let start = Math.max(1, page - 2);
        let end = Math.min(totalPages, page + 2);

        if (start > 1) pages.push(1, '...');
        for (let i = start; i <= end; i++) pages.push(i);
        if (end < totalPages) pages.push('...', totalPages);

        return pages;
    };

    const startItem = (page - 1) * pageSize + 1;
    const endItem = Math.min(page * pageSize, totalCount);

    return (
        <>
            {loading && <Spinner overlay={true} text="Loading pages..." />}

            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between mb-3">
                                <h5 className="card-title mb-0">All Pages</h5>
                                <Link to="/page/add" className='nav-link'>
                                    <button type="button" className="btn btn-primary">New Page</button>
                                </Link>
                            </div>

                            <div className="table-responsive position-relative">
                                <table className="table table-striped table-hover table-borderless align-middle">
                                    <thead className="table-dark">
                                        <tr>
                                            <th>PK</th>
                                            <th>Title</th>
                                            <th>Paramlink</th>
                                            <th>Meta Title</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!loading && data.length ? data.map((item) => (
                                            <tr key={item.pk}>
                                                <td>{item.pk}</td>
                                                <td>{item.title}</td>
                                                <td>{item.paramlink}</td>
                                                <td>{item.metatitle}</td>
                                                <td>
                                                    <i className="mdi mdi-tooltip-edit mdi-big text-primary me-2 pointer"
                                                        onClick={() => handleEdit(item.pk)}></i>
                                                </td>
                                            </tr>
                                        )) : (
                                            !loading && (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No pages found</td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination & Page Info */}
                            <div className="d-flex justify-content-between align-items-center mt-4 p-3 bg-light rounded">
                                <div className="d-flex align-items-center">
                                    <span className="text-muted">
                                        Showing <strong>{startItem}-{endItem}</strong> of <strong>{totalCount}</strong> Records
                                    </span>
                                </div>

                                <div className="d-flex align-items-center">
                                    <button
                                        className="btn btn-outline-primary btn-sm me-2"
                                        onClick={() => changePage(page - 1)}
                                        disabled={page === 1 || loading}
                                    >
                                        <i className="mdi mdi-chevron-left me-1"></i> Previous
                                    </button>

                                    <div className="btn-group mx-2" role="group">
                                        {pageNumbers().map((p, idx) =>
                                            p === '...' ? (
                                                <span key={idx} className="btn btn-outline-primary disabled">...</span>
                                            ) : (
                                                <button
                                                    key={idx}
                                                    className={`btn btn-sm ${p === page ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => changePage(p)}
                                                    disabled={loading}
                                                >
                                                    {p}
                                                </button>
                                            )
                                        )}
                                    </div>

                                    <button
                                        className="btn btn-outline-primary btn-sm ms-2"
                                        onClick={() => changePage(page + 1)}
                                        disabled={page === totalPages || loading}
                                    >
                                        Next <i className="mdi mdi-chevron-right ms-1"></i>
                                    </button>
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="text-muted small me-2">Show</span>
                                    <select
                                        value={pageSize}
                                        className="form-select form-select-sm border-primary shadow-sm"
                                        style={{ width: '70px' }}
                                        onChange={e => {
                                            setPageSize(Number(e.target.value));
                                            setPage(1);
                                        }}
                                        disabled={loading}
                                    >
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={75}>75</option>
                                    </select>
                                    <span className="text-muted small ms-2">Records</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default PagesList;
